import React from 'react';

export default function WhyLisa() {
  const advantages = [
    {
      icon: 'ri-translate-2',
      title: 'Speaks Mandarin',
      desc: 'Ensuring your brand has a local voice and a Western eye.',
    },
    {
      icon: 'ri-map-pin-2-line',
      title: 'Based in Shanghai',
      desc: 'I can be at your factory or manufacturer within hours. No flights, no jet lag, no delays.',
    },
    {
      icon: 'ri-shield-star-line',
      title: 'Scandinavian Values',
      desc: 'I understand Scandinavian values because I grew up with them, and I bring that perspective to every factory visit.',
    },
    {
      icon: 'ri-eye-line',
      title: 'Ongoing Presence',
      desc: 'Your eyes in China, every month: keeping your brand safe, transparent, and in control.',
    },
    {
      icon: 'ri-video-line',
      title: 'Visual Truth, Not Paperwork',
      desc: 'Real-time photos, videos, and voice notes. You feel the vibe of the factory floor through my lens.',
    },
    {
      icon: 'ri-user-heart-line',
      title: '100% Compliant & Confidential',
      desc: 'Operated according to Chinese laws. NDAs signed for every engagement.',
    },
  ];

  return (
    <section id="why" className="py-28 bg-[#F5F0E6]">
      <div className="max-w-6xl mx-auto px-6 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">
          <div>
            <div className="flex items-center gap-3 mb-5">
              <span className="w-8 h-[1px] bg-[#D98C74]"></span>
              <span className="text-[#D98C74] text-[12px] font-semibold tracking-[0.2em] uppercase">
                The Advantage
              </span>
            </div>
            <h2
              className="text-[30px] lg:text-[40px] font-bold text-[#2C3E50] leading-[1.15] mb-5"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Not an Agency.<br />Not a Consultant.<br />Your Person in China.
            </h2>
            <p className="text-[#2C3E50]/60 text-[16px] leading-[1.7] mb-10 max-w-md">
              I'm a Norwegian who's lived in Asia for 10 years and have worked closely with Chinese factories for much of that time. I bridge the gap between Western values and the realities of the production floor.
            </p>

            <div className="relative w-full h-[400px] rounded-lg overflow-hidden">
              <img
                src="https://static.readdy.ai/image/daecb691b20ad5ec02f24cf6c8ec8ccd/95dbf83a897b359cbee7868ba8f3c7b5.png"
                alt="Lisa - Norwegian factory inspector based in Guangzhou China"
                title="Brand Guardian Lisa - your eyes on the ground in China"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-[#2C3E50]/80 to-transparent p-6">
                <div className="text-white font-bold text-[18px]">Lisa Lopez</div>
                <div className="text-white/70 text-[13px]">
                  Founder & Owner of Brand Guardian, a division of Shanghai Lingxuan
                </div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 gap-5 lg:pt-20">
            {advantages.map((a) => (
              <div
                key={a.title}
                className="bg-white rounded-lg p-6 border border-[#D98C74]/15 hover:shadow-md transition-shadow duration-300 flex items-start gap-5"
              >
                <div className="w-10 h-10 bg-[#D98C74]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className={`${a.icon} text-[#D98C74] text-lg`}></i>
                </div>
                <div>
                  <h3 className="text-[15px] font-bold text-[#2C3E50] mb-1">
                    {a.title}
                  </h3>
                  <p className="text-[#2C3E50]/55 text-[13px] leading-[1.6]">
                    {a.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
